export default __webpack_public_path__ + "static/media/computadora-de-escritorio.47e545c5.png";